/* page-store.js — sort, AJAX add-to-cart, mini-cart, cursor, product modal. */
(function () {
  'use strict';

  var root = document.querySelector('[data-ps-root]');
  if (!root) return;

  var grid    = root.querySelector('[data-ps-grid]');
  var sortBtns = root.querySelectorAll('[data-ps-sort]');
  var miniTotal = root.querySelector('[data-ps-mini-total]');
  var minicart  = root.querySelector('[data-ps-minicart]');
  var biosLink  = root.querySelector('[data-ps-bios]');

  /* Crosshair cursor is now handled by the global /assets/bios-cursor.js
     loaded from layout/theme.liquid. The local #ps-cursor element +
     mousemove handler used to live here. */

  /* Escape HTML-attribute-unsafe characters when concatenating strings into
     HTML templates. Used for product titles / variant names whose contents
     come from merchant input and could contain quotes or angle brackets. */
  function escAttr(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  /* ---------- Sorting ---------- */
  function sortGrid(mode) {
    if (!grid) return;
    var cards = Array.prototype.slice.call(grid.querySelectorAll('.ps-card'));
    cards.sort(function (a, b) {
      if (mode === 'low')  return (parseInt(a.dataset.price, 10) || 0) - (parseInt(b.dataset.price, 10) || 0);
      if (mode === 'high') return (parseInt(b.dataset.price, 10) || 0) - (parseInt(a.dataset.price, 10) || 0);
      return (parseInt(b.dataset.published, 10) || 0) - (parseInt(a.dataset.published, 10) || 0);
    });
    var frag = document.createDocumentFragment();
    cards.forEach(function (c) { frag.appendChild(c); });
    grid.appendChild(frag);
  }

  sortBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      sortBtns.forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
      sortGrid(btn.getAttribute('data-ps-sort'));
    });
  });

  /* ---------- Format money ---------- */
  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      try { return window.Shopify.formatMoney(cents); } catch (e) {}
    }
    return '$' + (cents / 100).toFixed(2);
  }

  /* ---------- Cart UI sync ---------- */
  function updateCartUI(cart) {
    if (!cart) return;
    root.querySelectorAll('[data-ps-cartcount], [data-ps-mini-count]').forEach(function (el) {
      el.textContent = cart.item_count;
    });
    if (miniTotal) miniTotal.textContent = formatMoney(cart.total_price);
    if (minicart) {
      minicart.classList.remove('is-bump');
      void minicart.offsetWidth;
      minicart.classList.add('is-bump');
    }
  }

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(updateCartUI)
      .catch(function () {});
  }

  /* ---------- AJAX add to cart ---------- */
  function addToCart(variantId, btn) {
    if (!variantId || (btn && btn.disabled)) return;
    if (btn) {
      btn.disabled = true;
      btn._orig = btn.textContent;
    }
    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8', Accept: 'application/json' },
      body: 'id=' + encodeURIComponent(variantId) + '&quantity=1'
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () {
        if (btn) { btn.textContent = '[ ADDED \u2713 ]'; btn.classList.add('is-added'); }
        return fetchCart();
      })
      .catch(function () {
        if (btn) btn.textContent = '[ ERROR ]';
      })
      .then(function () {
        setTimeout(function () {
          if (btn) {
            btn.textContent = btn._orig || '[ ADD TO CART + ]';
            btn.classList.remove('is-added');
            btn.disabled = false;
          }
        }, 1400);
      });
  }

  /* Wire direct add-to-cart buttons on the grid */
  root.querySelectorAll('[data-ps-add]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      addToCart(btn.getAttribute('data-variant-id'), btn);
    });
  });

  /* ---------- Cart drawer ---------- */
  var cartDrawer = document.getElementById('ps-cart-drawer');
  var cartBody   = cartDrawer && cartDrawer.querySelector('[data-ps-cart-body]');
  var cartFoot   = cartDrawer && cartDrawer.querySelector('[data-ps-cart-foot]');
  var cartOpen   = false;

  function openCartDrawer() {
    if (!cartDrawer) return;
    cartOpen = true;
    cartDrawer.classList.add('is-open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    cartDrawer.setAttribute('aria-modal', 'true');
    document.body.classList.add('ps-cart-locked');
    loadCartDrawer();
  }
  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartOpen = false;
    cartDrawer.classList.remove('is-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    cartDrawer.removeAttribute('aria-modal');
    document.body.classList.remove('ps-cart-locked');
  }

  function loadCartDrawer() {
    if (!cartBody) return;
    cartBody.innerHTML = '<div class="ps-cart-drawer-loading">QUERYING /CART...</div>';
    if (cartFoot) cartFoot.innerHTML = '';
    fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart.items || cart.items.length === 0) {
          cartBody.innerHTML = '<div class="ps-cart-drawer-empty">// CART IS EMPTY</div>';
          if (cartFoot) cartFoot.innerHTML = '';
          return;
        }
        var html = '';
        cart.items.forEach(function (item) {
          var title = (item.product_title || item.title || 'ITEM').toUpperCase();
          if (title.length > 28) title = title.slice(0, 27) + '…';
          var price = formatMoney(item.final_line_price);
          var key = String(item.key || item.variant_id);
          html += '<div class="ps-cart-item" data-key="' + key + '">'
            + '<span class="ps-ci-qty">' + item.quantity + '×</span>'
            + '<span class="ps-ci-name">' + title + '</span>'
            + '<span class="ps-ci-price">' + price + '</span>'
            + '<button class="ps-ci-remove" data-key="' + key + '" aria-label="Remove">✕</button>'
            + '</div>';
        });
        cartBody.innerHTML = html;
        if (cartFoot) {
          cartFoot.innerHTML =
            '<div class="ps-cart-total"><span>TOTAL</span><span>' + formatMoney(cart.total_price) + '</span></div>'
            + '<a href="/checkout" class="ps-cart-checkout">[ PROCEED TO CHECKOUT ]</a>';
        }
        updateCartUI(cart);
      })
      .catch(function () {
        cartBody.innerHTML = '<div class="ps-cart-drawer-empty">// ERROR READING CART</div>';
      });
  }

  function removeCartItem(key, rowEl) {
    if (!rowEl || rowEl.classList.contains('is-removing')) return;
    rowEl.classList.add('is-removing');
    setTimeout(function () {
      fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      })
        .then(function () { loadCartDrawer(); fetchCart(); })
        .catch(function () { rowEl.classList.remove('is-removing'); });
    }, 300);
  }

  /* Hijack any [data-ps-cart-toggle] click — header link, mini-cart — to open drawer instead of /cart 404 */
  root.querySelectorAll('[data-ps-cart-toggle]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (cartOpen) closeCartDrawer(); else openCartDrawer();
    });
  });

  /* Close button + delegated remove */
  if (cartDrawer) {
    var closeBtn = cartDrawer.querySelector('[data-ps-cart-close]');
    if (closeBtn) closeBtn.addEventListener('click', closeCartDrawer);
    if (cartBody) {
      cartBody.addEventListener('click', function (e) {
        var btn = e.target.closest('.ps-ci-remove');
        if (!btn) return;
        e.stopPropagation();
        var key = btn.dataset.key;
        var row = cartBody.querySelector('.ps-cart-item[data-key="' + key + '"]');
        removeCartItem(key, row);
      });
    }
  }

  /* Click outside drawer or Esc to close */
  document.addEventListener('click', function (e) {
    if (!cartOpen) return;
    if (cartDrawer && cartDrawer.contains(e.target)) return;
    if (e.target.closest('[data-ps-cart-toggle]')) return;
    closeCartDrawer();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && cartOpen) closeCartDrawer();
  });

  /* ---------- Product detail modal ---------- */
  var overlay    = document.getElementById('ps-overlay');
  var ovBody     = document.getElementById('ps-ov-body');
  var ovTitle    = document.getElementById('ps-ov-title');
  var ovClose    = document.getElementById('ps-ov-close');
  var _ovImgs    = [];
  var _ovImgIdx  = 0;

  function openOverlay() {
    if (!overlay) return;
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeOverlay() {
    if (!overlay) return;
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  if (ovClose) ovClose.addEventListener('click', closeOverlay);
  if (overlay) {
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closeOverlay();
    });
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeOverlay();
  });

  function setCarouselImg(idx) {
    var imgA = document.getElementById('ps-ov-img-a');
    var imgB = document.getElementById('ps-ov-img-b');
    if (!imgA || !_ovImgs.length) return;
    _ovImgIdx = ((idx % _ovImgs.length) + _ovImgs.length) % _ovImgs.length;
    var src = _ovImgs[_ovImgIdx];
    /* cross-fade B → A */
    imgB.src = imgA.src;
    imgB.style.opacity = '1';
    imgA.style.opacity = '0';
    imgA.src = src;
    imgA.onload = function () {
      imgA.style.opacity = '1';
      imgB.style.opacity = '0';
    };
    var ctr = document.getElementById('ps-ov-counter');
    if (ctr && _ovImgs.length > 1) {
      ctr.textContent = '[' + String(_ovImgIdx + 1).padStart(2, '0') + '/' + String(_ovImgs.length).padStart(2, '0') + ']';
    }
  }

  function buildModal(product) {
    /* images */
    _ovImgs = (product.images || []).map(function (img) {
      /* Shopify CDN: replace or append width param */
      var src = img.src || img;
      return src.replace(/\?.*$/, '') + '?width=1200';
    });
    if (!_ovImgs.length && product.featured_image) _ovImgs = [product.featured_image];
    _ovImgIdx = 0;

    /* variants */
    var variants = product.variants || [];
    var singleVariant = variants.length === 1;
    var firstAvailableVariant = variants.find(function (v) { return v.available; }) || variants[0];

    /* price */
    var priceHTML = '';
    if (firstAvailableVariant) {
      var priceCents = firstAvailableVariant.price;
      var compareCents = firstAvailableVariant.compare_at_price;
      if (compareCents && compareCents > priceCents) {
        priceHTML = '<span class="ps-ov-price">' + formatMoney(priceCents) + '</span>'
                  + '<span class="ps-ov-price-was">' + formatMoney(compareCents) + '</span>';
      } else {
        priceHTML = '<span class="ps-ov-price">' + formatMoney(priceCents) + '</span>';
      }
    }

    /* meta */
    var vendor = product.vendor ? product.vendor.toUpperCase() : '';
    var sku    = (firstAvailableVariant && firstAvailableVariant.sku) ? firstAvailableVariant.sku : '';
    var metaLines = [];
    if (vendor) metaLines.push('VENDOR: ' + vendor);
    if (sku)    metaLines.push('SKU: ' + sku);
    metaLines.push('TYPE: ' + (product.product_type || 'UNCLASSIFIED').toUpperCase());

    /* variant selector */
    var variantHTML = '';
    if (!singleVariant && variants.length > 1) {
      variantHTML = '<div class="ps-ov-variants">'
        + '<div class="ps-ov-variant-label">SELECT VARIANT</div>'
        + '<select class="ps-ov-variant-select" id="ps-ov-variant-select">'
        + variants.map(function (v) {
            return '<option value="' + v.id + '" ' + (v.available ? '' : 'disabled') + '>'
              + escAttr(String(v.title).toUpperCase()) + (v.available ? '' : ' — SOLD OUT') + '</option>';
          }).join('')
        + '</select></div>';
    }

    /* carousel */
    var carouselHTML = '<div class="ps-ov-carousel" style="position:relative;">'
      + '<img class="ps-ov-img" id="ps-ov-img-a" src="' + escAttr(_ovImgs[0] || '') + '" alt="' + escAttr(product.title) + '" style="opacity:1;">'
      + '<img class="ps-ov-img ps-ov-img-b" id="ps-ov-img-b" src="" alt="" style="opacity:0;">'
      + '<div class="ps-ov-carousel-controls">'
      + (_ovImgs.length > 1
          ? '<button id="ps-ov-prev" aria-label="Previous">◄</button>'
            + '<span id="ps-ov-counter">[01/' + String(_ovImgs.length).padStart(2, '0') + ']</span>'
            + '<button id="ps-ov-next" aria-label="Next">►</button>'
          : '')
      + '</div>'
      + '</div>';

    /* description */
    var desc = (product.body_html || '').replace(/<[^>]+>/g, '').trim();
    if (desc.length > 320) desc = desc.slice(0, 317) + '…';

    /* add to cart / sold-out button */
    var cartBtnHTML = '';
    if (!product.available) {
      cartBtnHTML = '<button class="ps-ov-cart-btn" disabled style="opacity:.45;cursor:not-allowed">[ SOLD OUT ]</button>';
    } else {
      cartBtnHTML = '<button class="ps-ov-cart-btn" id="ps-ov-cart-btn">[ ADD TO SYSTEM CART ]</button>';
    }

    var infoHTML = '<div class="ps-ov-info">'
      + '<div class="ps-ov-name">' + escAttr(String(product.title).toUpperCase()) + '</div>'
      + priceHTML
      + variantHTML
      + '<div class="ps-ov-meta">' + metaLines.join('<br>') + '</div>'
      + (desc ? '<div class="ps-ov-desc">' + desc + '</div>' : '')
      + cartBtnHTML
      + '</div>';

    ovBody.innerHTML = carouselHTML + infoHTML;
    if (ovTitle) ovTitle.textContent = product.title.toUpperCase();

    /* carousel prev/next */
    var prevBtn = document.getElementById('ps-ov-prev');
    var nextBtn = document.getElementById('ps-ov-next');
    if (prevBtn) prevBtn.addEventListener('click', function () { setCarouselImg(_ovImgIdx - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { setCarouselImg(_ovImgIdx + 1); });

    /* variant select change */
    var varSel = document.getElementById('ps-ov-variant-select');
    if (varSel) {
      /* pre-select first available */
      if (firstAvailableVariant) {
        for (var oi = 0; oi < varSel.options.length; oi++) {
          if (String(varSel.options[oi].value) === String(firstAvailableVariant.id)) {
            varSel.selectedIndex = oi; break;
          }
        }
      }
      varSel.addEventListener('change', function () {
        var selVariant = variants.find(function (v) { return String(v.id) === varSel.value; });
        var cartBtn = document.getElementById('ps-ov-cart-btn');
        if (cartBtn && selVariant) {
          cartBtn.dataset.variantId = selVariant.id;
        }
      });
    }

    /* cart button */
    var cartBtn = document.getElementById('ps-ov-cart-btn');
    if (cartBtn) {
      var initialVid = firstAvailableVariant ? String(firstAvailableVariant.id) : '';
      cartBtn.dataset.variantId = initialVid;
      cartBtn.addEventListener('click', function () {
        var vid = cartBtn.dataset.variantId;
        if (!vid) return;
        addToCart(vid, cartBtn);
      });
    }
  }

  function openProductModal(handle) {
    if (!overlay || !ovBody) return;
    ovBody.innerHTML = '<div class="ps-ov-loading">[ LOADING UNIT DATA... ]</div>';
    if (ovTitle) ovTitle.textContent = '';
    openOverlay();

    fetch('/products/' + handle + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(buildModal)
      .catch(function () {
        ovBody.innerHTML = '<div class="ps-ov-loading">[ ERROR: UNIT DATA UNAVAILABLE ]</div>';
      });
  }

  /* Intercept all product card link clicks */
  if (grid) {
    grid.addEventListener('click', function (e) {
      /* ignore clicks on the add-to-cart button (handled above) */
      var addBtn = e.target.closest('[data-ps-add]');
      if (addBtn) return;

      var card = e.target.closest('.ps-card');
      if (!card) return;

      /* find handle from the view link or image link */
      var link = card.querySelector('a[href*="/products/"]');
      if (!link) return;

      var match = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
      if (!match) return;

      e.preventDefault();
      openProductModal(match[1]);
    });
  }

  /* ---------- Enter BIOS ---------- */
  if (biosLink) {
    biosLink.addEventListener('click', function () {
      try { sessionStorage.removeItem('bios_choice'); } catch (e) {}
    });
  }

  /* ---------- Initial sort = NEW ---------- */
  sortGrid('new');
})();
